// packages/a11y/src/index.js
import domReady from "@wordpress/dom-ready";
import addContainer from "./script/add-container";
import addIntroText from "./script/add-intro-text";
import { speak } from "./shared/index";
function setup() {
  const introText = document.getElementById("a11y-speak-intro-text");
  const containerAssertive = document.getElementById(
    "a11y-speak-assertive"
  );
  const containerPolite = document.getElementById("a11y-speak-polite");
  if (introText === null) {
    addIntroText();
  }
  if (containerAssertive === null) {
    addContainer("assertive");
  }
  if (containerPolite === null) {
    addContainer("polite");
  }
}
domReady(setup);
export {
  setup,
  speak
};
//# sourceMappingURL=index.js.map
